import { ProductAttributes, ProductKeys } from './types/ProductEnums';

export const commercetoolsConfig = {
  i18n: {
    useNuxtI18nConfig: true,
  },
  faceting: {
    pageOptions: [18],
    subcategoriesLimit: 100,
    filteringStrategy: ['filter', 'facets'],
    availableFacets: [
      {
        facet: 'categories.id',
        type: 'string',
        option: 'subtree("*")',
        name: 'category',
        filteringStrategy: 'query',
        countingProducts: true,
      },
      {
        facet: 'variants.attributes.master-variant-price.centAmount',
        type: 'number',
        name: 'price',
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.culture}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.culture,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.hairType}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.hairType,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.typeOfSkins}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.typeOfSkins,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.olfactoryUniverse}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.olfactoryUniverse,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.suitableFor}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.suitableFor,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.beautyProblems}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.beautyProblems,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.beautyProperties}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.beautyProperties,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.homeProblems}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.homeProblems,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.wellnessProblems}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.wellnessProblems,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.wellnessProperties}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.wellnessProperties,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.kitchenProblems}.label.{lang}`,
        type: 'string',
        name: ProductAttributes.kitchenProblems,
        filteringStrategy: ['filter', 'facets'],
        countingProducts: true,
      },
      {
        facet: `variants.attributes.${ProductAttributes.availableInCountries}.key`,
        type: 'string',
        name: ProductAttributes.availableInCountries,
        filteringStrategy: 'query',
      },
      {
        facet: `variants.attributes.${ProductKeys.isSellable}.key`,
        type: 'string',
        name: ProductKeys.isSellable,
        filteringStrategy: 'query',
      },
      {
        facet: 'variants.sku',
        type: 'string',
        name: 'skus',
        filteringStrategy: 'query',
      },
      {
        facet: 'slug.fr',
        type: 'string',
        name: 'slug_fr',
        filteringStrategy: 'query',
      },
      {
        facet: 'slug.en',
        type: 'string',
        name: 'slug_en',
        filteringStrategy: 'query',
      },
      {
        facet: 'slug.de',
        type: 'string',
        name: 'slug_de',
        filteringStrategy: 'query',
      },
      {
        facet: 'slug.es',
        type: 'string',
        name: 'slug_es',
        filteringStrategy: 'query',
      },
      {
        facet: 'slug.it',
        type: 'string',
        name: 'slug_it',
        filteringStrategy: 'query',
      },
      {
        facet: `variants.attributes.${ProductKeys.isProductDiscontinued}`,
        type: 'string',
        name: ProductKeys.isProductDiscontinued,
        filteringStrategy: 'filter',
      },
    ],
    sortingOptions: [
      {
        id: 'pertinence',
        name: 'sort.pertinence',
        facet: 'categoryOrderHints.{categoryId}',
        direction: 'asc',
      },
      {
        id: 'latest',
        name: 'sort.latest',
        facet: 'createdAt',
        direction: 'desc',
      },
      {
        id: 'oldest',
        name: 'sort.oldest',
        facet: 'createdAt',
        direction: 'asc',
      },
      {
        id: 'bestseller',
        name: 'sort.bestsellers',
        facet: 'variants.attributes.best-seller',
        direction: 'desc',
      },
      {
        id: 'name-asc-lang_fr',
        name: 'sort.nameAsc',
        facet: 'name.fr',
        direction: 'asc',
      },
      {
        id: 'name-asc-lang_it',
        name: 'sort.nameAsc',
        facet: 'name.it',
        direction: 'asc',
      },
      {
        id: 'name-desc-lang_fr',
        name: 'sort.nameDesc',
        facet: 'name.fr',
        direction: 'desc',
      },
      {
        id: 'name-desc-lang_it',
        name: 'sort.nameDesc',
        facet: 'name.it',
        direction: 'desc',
      },
      {
        id: 'price-asc',
        name: 'sort.priceAsc',
        facet: 'variants.attributes.master-variant-price.centAmount',
        direction: 'asc',
      },
      {
        id: 'price-desc',
        name: 'sort.priceDesc',
        facet: 'variants.attributes.master-variant-price.centAmount',
        direction: 'desc',
      },
    ],
  },
};
